import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-accountant-welcome-modal',
  templateUrl: './accountant-welcome-modal.component.html',
  styleUrls: ['./accountant-welcome-modal.component.scss']
})
export class AccountantWelcomeModalComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onDontShowAgain = new EventEmitter<void>();

  dontShowAgain: boolean = false;
  curentLang: string = '';
  accountantSystemUrl: string = 'https://accountant.thinvoices.com/auth/login';

  constructor(public translate: TranslateService) {
    this.curentLang = localStorage.getItem('curentLang') || 'ar';
  }

  closeModal(): void {
    if (this.dontShowAgain) {
      this.onDontShowAgain.emit();
    }
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  goToAccountantSystem(): void {
    if (this.dontShowAgain) {
      this.onDontShowAgain.emit();
    }
    window.open(this.accountantSystemUrl, '_blank');
    this.closeModal();
  }

  onCheckboxChange(event: any): void {
    this.dontShowAgain = event.target.checked;
  }
}
